const SET_CONTENT = 'SET_CONTENT';

export { SET_CONTENT };
